import commons from './commons';
import identity_server_application from './identityServer';
import login from './login';
import reset_credentials from './resetCredentials';

export const locales = {
  en: {
    translation: {
      commons,
      identity_server_application,
      login,
      reset_credentials,
    },
  },
};
